import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import RunningJourneyPopup from "./RunningJourneyPopup";
import axios from "axios";

function RunningJourneyBtn() {
  const [open, setOpen] = useState(false);
  const [totalJourneys, setTotalJourneys] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleOpen = () => {
    setOpen(true);
    // When opening, fetch the data (or you could fetch earlier)
    fetchTotalJourneys();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchTotalJourneys = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        "https://v3.dhundhoo.com/superAdmin/totalRunningJourney"
      );
      // Inspect what the API returns (e.g. { total: 330 } or “330”)
      // Adjust this accordingly
      const data = response.data;
      // Suppose response is { totalRunningJourney: 330 } — adapt as per API:
      const total = data.totalRunningJourney;
      setTotalJourneys(total);
    } catch (err) {
      console.error("Error fetching total journeys:", err);
      setError("Failed to fetch");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDBox display="flex" justifyContent="center" mt={4}>
      <MDBox display="flex" justifyContent="center">
        <MDButton variant="contained" color="info" onClick={handleOpen}>
          Show Running Journey
        </MDButton>
      </MDBox>
     
      <RunningJourneyPopup
        open={open}
        handleClose={handleClose}
        totalJourneys={totalJourneys}
        loading={loading}
        error={error}
      />
    </MDBox>
  );
}

export default RunningJourneyBtn;
